import { PERSONAL, REFI, INSCHOOL } from 'common/const/verticalNames'

const LENDER_SLAG_TO_TRACKING_NAME_MAP = {
  [PERSONAL]: {
    ava: 'avant',
    frp: 'freedom-plus',
    ldc: 'lending-club',
    'pl-discover': 'discover',
    sofi: 'sofi-personal',
    ups: 'upstart',
    pro: 'prosper',
  },
  [REFI]: {
    'citizens-bank': 'citizens',
  },
  [INSCHOOL]: {
    'cog-fin': 'customchoice',
    cas: 'collegeaveundergraduate',
    'sallie-mae': 'salliemae',
    'citizens-bank': 'citizens',
  },
}

export default LENDER_SLAG_TO_TRACKING_NAME_MAP
